import { registerComponent } from '@gig/magic-common';
import LandingPageComponent from './landing-page.vue.js';

var Landing = registerComponent(LandingPageComponent);

export { Landing };
